/*
ABOUT >>
THIS INPUT USED FOR CHECK DUPLICATE ON ADD AND EDIT
 

ACTIVE >>
ITS IN RUNNING POSITION

UPDATES >>
IT WILL BE UPDATE MAKE THIS INPUT INTO CLASS COMPONENT OF REACT AND RETURN AS FUNCTION 
*/

import React, { useState, useEffect } from 'react';
import CheckDuplicate from '../check-duplicate/check-duplicate';

const DynamicInputComponent = ({ dynamicFields, dataList, wrapperId  ,IsAdd ,duplicateType ,parentColumn ,selectedRow}) => {
    console.log(dynamicFields, dataList, wrapperId  ,IsAdd ,duplicateType ,parentColumn ,selectedRow)
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [checkDuplicateValue, setCheckDuplicateValue] = useState('');
  const [inputValues, setInputValues] = useState(dynamicFields);

//   const handleInputChange = (e, key) => {
//     setInputValues({ ...inputValues, [key]: e.target.value });
//   };
  useEffect(() => {
    setInputValues(dynamicFields);
  }, [dynamicFields]);
  
  useEffect(() => {
    setTimeout(() => {
      setCheckDuplicate(true);
      if(IsAdd == false){
        const buttonSelector = `#${wrapperId}_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`;
        document.querySelector(buttonSelector).style.visibility='visible';
        }
    }, 500);
  }, []);

  useEffect(() => {
    if (checkDuplicate) {
      const isComplete = Object.values(inputValues).every(value => value !== undefined && value !== '');
     
      if (isComplete) {
        let isDuplicate 
        if(duplicateType == 'with'){
        if(IsAdd == true){
         isDuplicate = CheckDuplicate.withCombination(dataList, Object.keys(inputValues), inputValues);
        }else{
            let array = dataList.filter(obj => obj[parentColumn] !== selectedRow[parentColumn]);
             isDuplicate = CheckDuplicate.withCombination(array, Object.keys(inputValues), inputValues);
         }
        }else{
            if(IsAdd == true){
             isDuplicate = CheckDuplicate.withOutCombination(dataList, Object.keys(inputValues), inputValues);
            }else{
                let array = dataList.filter(obj => obj[parentColumn] !== selectedRow[parentColumn]);
                 isDuplicate = CheckDuplicate.withOutCombination(array, Object.keys(inputValues), inputValues);
             }
            
        }
        // fullYarnCountGrid_dialogEdit_wrapper
        const buttonSelector = `#${wrapperId}_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`;

        if (!isDuplicate) {
          document.querySelector(buttonSelector).style.visibility = 'visible';
          setCheckDuplicateValue('');
        } else {
          document.querySelector(buttonSelector).style.visibility = 'hidden';
          setCheckDuplicateValue('Duplicate Value Detected!');
        }
      }
    }
  }, [inputValues, checkDuplicate, dataList, wrapperId]);

  return (
    <div id='duplicate-div'>
      {/* {Object.keys(inputValues).map((key) => (
        <div key={key}>
          <label>{key}</label>
          <input type="text" value={inputValues[key]} onChange={(e) => handleInputChange(e, key)} />
        </div>
      ))} */}

      <h3 className="duplicate" style={checkDuplicateValue !== '' ? { transform: 'scale(1)' } : {}}>
        {checkDuplicateValue}
      </h3>
    </div>
  );
};

export default DynamicInputComponent;
